var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vertical-step',{attrs:{"title":_vm.$t('virtualColleague.autoLead.sideBar.optionalLabel'),"is-current":_vm.currentStep === 4,"is-completed":_vm.currentStep > 4}})}
var staticRenderFns = []

export { render, staticRenderFns }